import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroBanner from './components/HeroBanner';
import HotGossip from './components/HotGossip';
import CategoryGrid from './components/CategoryGrid';
import LatestNews from './components/LatestNews';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';

const baseUrl = 'http://hn720.cn/';

export default function Home() {
  const schemaJson = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${baseUrl}/#website`,
        url: baseUrl,
        name: '吃瓜网在线',
        description: '吃瓜网在线 - 51吃瓜网在线观看、91吃瓜网在线吃瓜、黑料吃瓜网在线观看。每日更新网红塌房爆料与实时吃瓜视频，承接在线吃瓜搜索意图。',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'WebPage',
        '@id': `${baseUrl}/#webpage`,
        url: baseUrl,
        name: '吃瓜网在线 | 网红塌房爆料实时视频',
        isPartOf: { '@id': `${baseUrl}/#website` },
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'Organization',
        '@id': `${baseUrl}/#organization`,
        name: '吃瓜网在线',
        url: baseUrl,
        description: '国内领先的娱乐八卦资讯聚合平台',
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="吃瓜网在线 | 51吃瓜网在线观看 | 91吃瓜网在线吃瓜 | 网红塌房爆料实时视频"
        description="吃瓜网在线🔔直达51吃瓜网在线观看、91吃瓜网在线吃瓜与黑料吃瓜网在线观看，💎每日更新网红塌房爆料与实时吃瓜视频，承接在线吃瓜搜索意图。"
        keywords="51吃瓜网在线观看,91吃瓜网在线吃瓜,黑料吃瓜网在线观看,吃瓜网在线,在线吃瓜,网红塌房,吃瓜视频,51吃瓜在线,黑料吃瓜在线,51吃瓜网在线,吃瓜网在线入口,实时吃瓜"
        canonicalUrl={baseUrl}
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20news%20website%20og%20image%2C%20warm%20crimson%20and%20amber%20tones%2C%20bold%20graphic%20design%2C%20dramatic%20atmosphere%2C%20editorial%20style%2C%20clean%20simple%20background%2C%20no%20text&width=1200&height=630&seq=og-home&orientation=landscape"
        schemaJson={schemaJson}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <HotGossip />
          <CategoryGrid />
          <LatestNews />
          <ReviewSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}